import { SuggestedQueriesTaxonomy } from '../base/taxonomy/Taxonomies.js';
import localize from '../util/localize.js';
import { SUGGESTED_SEACH_QUERY_SUBMITTED_LABEL } from '../util/analyticsConstants.js';

var MAX_NUMBER_OF_RESULTS = 8;
var convertSuggestedQueriesResponseToComboboxItems = function convertSuggestedQueriesResponseToComboboxItems(filterText, suggestedQueriesResponse, locale) {
  var items = extractSuggestedQueries(suggestedQueriesResponse);
  return {
    isLoading: false,
    loadingState: 'idle',
    items: items.length > 0 ? [{
      name: localize('suggestedQueries', locale),
      taxonomyId: SuggestedQueriesTaxonomy.id,
      items: items
    }] : [],
    selectedKeys: new Set(),
    filterText: filterText,
    sortDescriptor: {
      key: 'popularity',
      direction: 'descending',
      column: 'query'
    }
  };
};
var convertSuggestedQueriesResponseToTrackingInput = function convertSuggestedQueriesResponseToTrackingInput(filterText, suggestedQueriesResponse) {
  var _querySuggestionIndex, _querySuggestionIndex2, _querySuggestionIndex3;
  var querySuggestionIndexResults = suggestedQueriesResponse.results[0];
  return {
    query: filterText,
    taxonomyId: 'Suggested Search',
    numberOfResultsToShow: MAX_NUMBER_OF_RESULTS < ((_querySuggestionIndex = querySuggestionIndexResults.nbHits) !== null && _querySuggestionIndex !== void 0 ? _querySuggestionIndex : 0) ? MAX_NUMBER_OF_RESULTS : (_querySuggestionIndex2 = querySuggestionIndexResults.nbHits) !== null && _querySuggestionIndex2 !== void 0 ? _querySuggestionIndex2 : 0,
    indexName: (_querySuggestionIndex3 = querySuggestionIndexResults.index) !== null && _querySuggestionIndex3 !== void 0 ? _querySuggestionIndex3 : '',
    results: extractSuggestedQueries(suggestedQueriesResponse),
    rules: []
  };
};
var extractSuggestedQueries = function extractSuggestedQueries(suggestedQueriesResponse) {
  return suggestedQueriesResponse.results.flatMap(function (result) {
    return result.hits.map(convertQuerySuggestionHitToComboboxItem);
  }).slice(0, MAX_NUMBER_OF_RESULTS);
};
var convertQuerySuggestionHitToComboboxItem = function convertQuerySuggestionHitToComboboxItem(hit) {
  var _hit$_highlightResult;
  return {
    objectID: hit.objectID,
    title: hit.query,
    isSuggestedQuery: true,
    trackingLabel: SUGGESTED_SEACH_QUERY_SUBMITTED_LABEL,
    popularity: hit.popularity,
    highlightResult: (_hit$_highlightResult = hit._highlightResult) === null || _hit$_highlightResult === void 0 || (_hit$_highlightResult = _hit$_highlightResult.query) === null || _hit$_highlightResult === void 0 ? void 0 : _hit$_highlightResult.value,
    _rankingInfo: hit._rankingInfo
  };
};

export { convertSuggestedQueriesResponseToComboboxItems, convertSuggestedQueriesResponseToTrackingInput };
//# sourceMappingURL=algoliaService.js.map
